// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"CasesHero_sectionContainer__5qz_S","textContainer":"CasesHero_textContainer__FVgKW","firstWord":"CasesHero_firstWord__Kd6Ws"};